module.exports = __webpack_public_path__ + "img/bk2.e5c228e0.jpg";